module.exports = __webpack_public_path__ + "img/moodboard_roast.8bf1fe1a.png";